import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../common/ModelSave";
import { CancelButton, SaveButton } from "../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const Editcommissionmodal = (props) => {
  const id = props.show;
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [data, setData] = useState({});

  const getEditData = async () => {
    try {
      const response = await getData(`/admin/vendor/${id}`);

      if (response?.data) {
        reset({ commission: response.data.commission });
        setData(response.data);
      }
    } catch (error) {
      console.error("Error fetching edit data:", error);
    }
  };

  useEffect(() => {
    if (id) {
      getEditData();
    }
  }, [id]);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const d = new FormData();

      d.append("commission_percentage", data?.commission_percentage);

      const response = await postData(
        `/admin/vendor/editcommission/check/${id}`,
        d,
      );

      if (response?.success) {
        await setShowModal({ code: response?.code, message: response?.data });
      } else {
        await setShowModal({ code: response?.code, message: response?.data });
      }

      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit {data?.first_name}'s Commission
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <Form onSubmit={() => handleSubmit(onSubmit)} role="form"> */}
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Commission</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="Number"
                          min={0}
                          max={70}
                          name="commission"
                          placeholder="commission_percentage"
                          className={classNames("", {
                            "is-invalid": errors?.commission,
                          })}
                          {...register("commission_percentage", {
                            required: "commission percentage is required",
                            validate: (value) => {
                              if (!value)
                                return "commission percentage is required";
                              // Validate percentage discount
                              if (parseFloat(value) < 1) {
                                return "commission percentage should not be less then 1";
                              }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                      </InputGroup>
                      {errors?.commission_percentage && (
                        <span className="text-danger">
                          {errors?.commission_percentage?.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <CancelButton
                    name={"cancel"}
                    handleClose={props.handleClose}
                  />

                  {/* <SaveButton
                                   name={"save"}
                                   handleSubmit={handleSubmit(onSubmit)}
                                    /> */}

                  {/* <SaveButton
                                        name={"save"}
                                        onClick={handleSubmit(onSubmit)}
                                    /> */}
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default Editcommissionmodal;
